import { Link } from "react-router-dom";
import NewsCard from "@/components/feature/NewsCard";
import SectionHeading from "@/components/base/SectionHeading";
import { newsList } from "@/mocks/news";

export default function LatestNews() {
  const [featured, ...rest] = newsList;
  const sideList = rest.slice(0, 3);

  return (
    <section className="px-4 md:px-8 py-12 md:py-16 bg-background-50">
      <SectionHeading
        eyebrow="Latest News"
        title="最新资讯"
        description="第一时间了解森泽佳奈的最新动态、活动公告与作品进展。"
        morePath="/news"
      />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
        <div className="lg:col-span-2">
          <NewsCard item={featured} variant="wide" />
        </div>
        <div className="flex flex-col gap-4">
          {sideList.map((item) => (
            <Link
              key={item.id}
              to={`/detail/${item.id}`}
              className="group flex gap-4 p-3 bg-background-50 border border-background-200 rounded-lg hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="w-24 h-20 rounded-md overflow-hidden bg-background-200 shrink-0">
                <img
                  src={item.cover}
                  alt={item.title}
                  title={`${item.title} - 森泽佳奈资讯`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex flex-col justify-between min-w-0">
                <h3 className="font-medium text-sm text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug line-clamp-2">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500 flex items-center gap-1 mt-2">
                  <i className="ri-calendar-line"></i>
                  {item.date}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}